<template>
  <div class="choose-class-page">
    <div class="deco deco-1"></div>
    <div class="deco deco-2"></div>
    <div class="choose-card">
      <div class="card-header">
        <div class="card-emoji"><i class="el-icon-reading"></i></div>
        <div class="card-title">欢迎加入青少年人工智能高水平创新人才培养 课程平台</div>
        <div class="card-subtitle">首次登录，请填写你的基本信息，开启 AI 学习之旅</div>
      </div>
      <div class="card-body">
        <div class="form-item">
          <div class="form-label">学校</div>
          <el-select size="medium" v-model="school" filterable clearable placeholder="请选择或输入关键字搜索学校" style="width:100%">
            <el-option v-for="(item,index) in schoolList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="form-label">年级</div>
          <el-select size="medium" v-model="grade" placeholder="请选择年级" style="width:100%">
            <el-option v-for="item in gradeOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="form-label">姓名</div>
          <el-input size="medium" v-model="name" placeholder="请输入你的姓名" style="width:100%"></el-input>
        </div>
        <div class="form-row">
          <div class="form-item form-half">
            <div class="form-label">年龄</div>
            <el-input size="medium" type="number" v-model="age" placeholder="请输入年龄" style="width:100%"></el-input>
          </div>
          <div class="form-item form-half">
            <div class="form-label">性别</div>
            <el-select size="medium" v-model="sex" placeholder="请选择性别" style="width:100%">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <el-button class="submit-btn" type="primary" size="medium" :loading="submitting" @click="submit">确认提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { chooseClass, getApeSchoolList, getDictByCode } from '../../api/api'
  export default {
    data() {
      return {
        school: "",
        grade: "",
        name: "",
        age: "",
        sex: "",
        schoolList: [],
        gradeOptions: [],
        submitting: false
      }
    },
    mounted() {
      this.loadSchools()
      this.loadGrades()
    },
    methods: {
      loadSchools() {
        getApeSchoolList().then(res => {
          if (res.code == 1000) {
            this.schoolList = res.data
          }
        })
      },
      loadGrades() {
        getDictByCode({code: 'grade'}).then(res => {
          if (res.code == 1000) {
            this.gradeOptions = res.data
          }
        })
      },
      submit() {
        if (!this.school) {
          this.$message({ type: 'warning', message: '请选择学校' })
          return
        }
        if (!this.grade) {
          this.$message({ type: 'warning', message: '请选择年级' })
          return
        }
        if (!this.name.trim()) {
          this.$message({ type: 'warning', message: '请输入姓名' })
          return
        }
        if (!this.age) {
          this.$message({ type: 'warning', message: '请输入年龄' })
          return
        }
        if (this.sex === "") {
          this.$message({ type: 'warning', message: '请选择性别' })
          return
        }
        this.submitting = true
        chooseClass({ school: this.school, grade: this.grade, name: this.name.trim(), age: this.age, sex: this.sex }).then(res => {
          this.submitting = false
          if (res.code == 1000) {
            this.$message({ type: 'success', message: '提交成功！' })
            // 更新本地用户信息
            var userInfo = JSON.parse(window.localStorage.getItem("user_info") || "{}")
            userInfo.school = this.school
            userInfo.grade = this.grade
            userInfo.userName = this.name.trim()
            userInfo.age = this.age
            userInfo.sex = this.sex
            window.localStorage.setItem("user_info", JSON.stringify(userInfo))
            this.$router.push("/")
          } else {
            this.$message.error(res.message)
          }
        }).catch(() => {
          this.submitting = false
        })
      }
    }
  }
</script>

<style scoped>
  .choose-class-page {
    position: relative;
    min-height: 100vh;
    background: var(--grad-hero);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow: hidden;
  }
  .deco { position: absolute; border-radius: 50%; }
  .deco-1 {
    width: 380px; height: 380px; left: -110px; top: -110px;
    background: radial-gradient(circle, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 70%);
  }
  .deco-2 {
    width: 320px; height: 320px; right: -90px; bottom: -110px;
    background: radial-gradient(circle, rgba(255, 224, 102, 0.22) 0%, rgba(255,255,255,0) 70%);
  }
  .choose-card {
    position: relative;
    z-index: 2;
    width: 500px;
    background: #FFFFFF;
    border-radius: var(--radius-lg);
    box-shadow: 0 24px 60px rgba(20, 20, 80, 0.30);
    overflow: hidden;
  }
  .card-header {
    background: var(--grad-primary);
    padding: 34px 30px 30px;
    text-align: center;
  }
  .card-emoji {
    font-size: 40px;
    color: #FFFFFF;
    margin-bottom: 10px;
  }
  .card-title {
    color: #FFFFFF;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 2px;
  }
  .card-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    margin-top: 8px;
    letter-spacing: 1px;
  }
  .card-body {
    padding: 34px;
  }
  .form-item {
    margin-bottom: 20px;
  }
  .form-row {
    display: flex;
    gap: 12px;
  }
  .form-half {
    flex: 1;
  }
  .form-label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 8px;
    letter-spacing: 1px;
  }
  .submit-btn {
    width: 100%;
    height: 44px;
    font-size: 15px;
    letter-spacing: 4px;
    border-radius: 999px;
    margin-top: 6px;
  }
</style>
